export const formatDateForMD = (date: string): string => {
  return $core.$dayjs(date).format('M/D')
}
